import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
import type { NextGenToken } from "@/entities/INextgen";
import { commonApiFetch } from "@/services/api/common-api";
const FETCH_SIZE = 50;
const DISPLAY_BUFFER = 20;
const FETCH_TRIGGER = 10;
interface UseTokenSlideshowReturn {
  displayTokens: NextGenToken[];
  isLoading: boolean;
  hasMore: boolean;
  onSlideChange: (slideIndex: number) => void;
}
export function useTokenSlideshow(collectionId, t0) {
  const $ = _c(25);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initialTokens = t1;
  const [allTokens, setAllTokens] = useState(initialTokens);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [displayTokens, setDisplayTokens] = useState(t2);
  const [currentSlide, setCurrentSlide] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreOnServer, setHasMoreOnServer] = useState(false);
  const [isLoading, setIsLoading] = useState(initialTokens.length === 0);
  let t3;
  if ($[3] !== collectionId || $[4] !== currentPage) {
    t3 = async () => {
      commonApiFetch({
        endpoint: `nextgen/collections/${collectionId}/tokens?page_size=${FETCH_SIZE}&page=${currentPage}&sort=random`
      }).then(response => {
        setAllTokens(prev => [...prev, ...response.data]);
        setHasMoreOnServer(response.next);
        setIsLoading(false);
      });
    };
    $[3] = collectionId;
    $[4] = currentPage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const fetchMoreTokens = t3;
  let t4;
  let t5;
  if ($[6] !== fetchMoreTokens || $[7] !== initialTokens.length) {
    t4 = () => {
      if (initialTokens.length === 0) {
        fetchMoreTokens();
      }
    };
    t5 = [fetchMoreTokens, initialTokens.length];
    $[6] = fetchMoreTokens;
    $[7] = initialTokens.length;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[10] !== allTokens || $[11] !== displayTokens.length) {
    t6 = () => {
      if (allTokens.length > 0 && displayTokens.length === 0) {
        setDisplayTokens(allTokens.slice(0, DISPLAY_BUFFER));
      }
    };
    t7 = [allTokens, displayTokens.length];
    $[10] = allTokens;
    $[11] = displayTokens.length;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[14] !== allTokens || $[15] !== currentSlide || $[16] !== displayTokens.length || $[17] !== hasMoreOnServer) {
    t8 = () => {
      const remainingInDisplay = displayTokens.length - currentSlide;
      const remainingInAll = allTokens.length - displayTokens.length;
      if (remainingInDisplay <= 5 && remainingInAll > 0) {
        const newDisplayLength = Math.min(displayTokens.length + 10, allTokens.length);
        setDisplayTokens(allTokens.slice(0, newDisplayLength));
      }
      if (remainingInAll <= FETCH_TRIGGER && hasMoreOnServer) {
        setCurrentPage(_temp);
      }
    };
    t9 = [currentSlide, displayTokens.length, allTokens, hasMoreOnServer];
    $[14] = allTokens;
    $[15] = currentSlide;
    $[16] = displayTokens.length;
    $[17] = hasMoreOnServer;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  useEffect(t8, t9);
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = slideIndex => {
      setCurrentSlide(slideIndex);
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const onSlideChange = t10;
  const t11 = Boolean(hasMoreOnServer);
  let t12;
  if ($[21] !== displayTokens || $[22] !== isLoading || $[23] !== t11) {
    t12 = {
      displayTokens,
      isLoading,
      hasMore: t11,
      onSlideChange
    };
    $[21] = displayTokens;
    $[22] = isLoading;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}
function _temp(prev_0) {
  return prev_0 + 1;
}